// src/Pages/Landing/JoyrideLahtiLanding.jsx
import React from "react";
import JoyrideKaupunkiLanding from "./JoyrideKaupunkiLanding.jsx";
import joyrideHero from "../../assets/Joyride_04.webp";

export default function JoyrideLahtiLanding() {
  return (
    <JoyrideKaupunkiLanding
      city="Lahti"
      maakunta="Päijät-Häme"
      nearbyAreas={[
        "Hollola",
        "Orimattila",
        "Heinola",
        "Asikkala",
        "Padasjoki",
        "Iitti"
      ]}
      cityText="Bilebändi Joyride tekee keikkoja Lahdessa ja Päijät-Hämeen alueella tapahtuman luonteesta, aikataulusta ja matkasta riippuen. Lahti sopii Bilebändi Joyridelle hyvin esimerkiksi häihin, yritysjuhliin, pikkujouluihin, syntymäpäiville ja kesäjuhliin, kun juhliin halutaan energinen livebändi."
      logisticsText="Lahden keikoissa kokonaisuus sovitaan aina tapahtumapaikan, aikataulun ja keikan keston mukaan. Bilebändi Joyridellä on oma kuljetus, oma äänentoisto ja valotekniikka, mikä helpottaa juhlan suunnittelua etenkin silloin, kun tapahtumapaikalla ei ole valmista tekniikkaa."
      bookingLink="/#varaa"
      heroImage={joyrideHero}
    />
  );
}